const anchors = document.querySelectorAll('a');
if (anchors && anchors.length) {
  for (const anchor of anchors) {
    if (anchor.href.includes('#')) {
      const id = anchor.href.split('#')[1];

      anchor.addEventListener('click', e => {
        const scrollToElement = document.getElementById(id);
        if (scrollToElement) {
          e.preventDefault();
          scrollToElement.scrollIntoView({
            behavior: 'smooth',
          });
        }
      });
    }
  }
}
